// extracted by mini-css-extract-plugin
export default {"tooltipWidth":"350","tooltipHeight":"200"};